<ng-template #settingsTemplate>
    <app-tool-setting label="Getallenlijn">
        <app-check-box
            label="Toon getallenlijn"
            [checked]="showNumberLine"
            (checkedChange)="showNumberLine = $event"
        ></app-check-box>
    </app-tool-setting>
    @if (showNumberLine) {
    <app-tool-setting label="Getallen op getallenlijn">
        <div class="options-grid">
            <app-check-box
                label="Getallen"
                [checked]="showNumbers"
                (checkedChange)="showNumbers = $event"
            ></app-check-box>
            <app-check-box
                label="Eenheden"
                [checked]="showUnits"
                (checkedChange)="showUnits = $event"
            ></app-check-box>
        </div>
    </app-tool-setting>
    }
    <app-tool-setting label="Label">
        <app-svg-input [options]="svgList" [parent]="instance"></app-svg-input>
    </app-tool-setting>
</ng-template>
<ng-template #contentTemplate>
    <svg
        class="slider"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 878.7 8.4"
        style="enable-background: new 0 0 878.7 8.4"
        xml:space="preserve"
    >
        <style type="text/css">
            .chain100-hide-ball path {
                fill: transparent;
            }

            .stChain1000 {
                fill: none;
                stroke: #000000;
                stroke-miterlimit: 10;
            }

            .stChain1001 {
                fill: url(#SVGID_1_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain1002 {
                fill: url(#SVGID_2_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain1003 {
                fill: url(#SVGID_3_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain1004 {
                fill: url(#SVGID_4_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain1005 {
                fill: url(#SVGID_5_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain1006 {
                fill: url(#SVGID_6_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain1007 {
                fill: url(#SVGID_7_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain1008 {
                fill: url(#SVGID_8_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain1009 {
                fill: url(#SVGID_9_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10010 {
                fill: url(#SVGID_10_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10011 {
                fill: #e5232b;
            }

            .stChain10012 {
                opacity: 0.3;
            }

            .stChain10013 {
                fill: #ffffff;
            }

            .stChain10014 {
                fill: url(#SVGID_11_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10015 {
                fill: url(#SVGID_12_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10016 {
                fill: url(#SVGID_13_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10017 {
                fill: url(#SVGID_14_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10018 {
                fill: url(#SVGID_15_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10019 {
                fill: url(#SVGID_16_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10020 {
                fill: url(#SVGID_17_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10021 {
                fill: url(#SVGID_18_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10022 {
                fill: url(#SVGID_19_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10023 {
                fill: #dadada;
            }

            .stChain10024 {
                opacity: 0.6;
            }

            .stChain10025 {
                fill: url(#SVGID_20_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10026 {
                fill: url(#SVGID_21_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10027 {
                fill: url(#SVGID_22_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10028 {
                fill: url(#SVGID_23_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10029 {
                fill: url(#SVGID_24_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10030 {
                fill: url(#SVGID_25_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10031 {
                fill: url(#SVGID_26_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10032 {
                fill: url(#SVGID_27_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10033 {
                fill: url(#SVGID_28_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10034 {
                fill: url(#SVGID_29_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10035 {
                fill: url(#SVGID_30_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10036 {
                fill: url(#SVGID_31_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10037 {
                fill: url(#SVGID_32_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10038 {
                fill: url(#SVGID_33_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10039 {
                fill: url(#SVGID_34_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10040 {
                fill: url(#SVGID_35_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10041 {
                fill: url(#SVGID_36_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10042 {
                fill: url(#SVGID_37_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10043 {
                fill: url(#SVGID_38_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10044 {
                fill: url(#SVGID_39_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10045 {
                fill: url(#SVGID_40_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10046 {
                fill: url(#SVGID_41_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10047 {
                fill: url(#SVGID_42_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10048 {
                fill: url(#SVGID_43_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10049 {
                fill: url(#SVGID_44_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10050 {
                fill: url(#SVGID_45_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10051 {
                fill: url(#SVGID_46_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10052 {
                fill: url(#SVGID_47_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10053 {
                fill: url(#SVGID_48_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10054 {
                fill: url(#SVGID_49_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10055 {
                fill: url(#SVGID_50_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10056 {
                fill: url(#SVGID_51_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10057 {
                fill: url(#SVGID_52_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10058 {
                fill: url(#SVGID_53_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10059 {
                fill: url(#SVGID_54_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10060 {
                fill: url(#SVGID_55_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10061 {
                fill: url(#SVGID_56_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10062 {
                fill: url(#SVGID_57_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10063 {
                fill: url(#SVGID_58_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10064 {
                fill: url(#SVGID_59_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10065 {
                fill: url(#SVGID_60_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10066 {
                fill: url(#SVGID_61_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10067 {
                fill: url(#SVGID_62_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10068 {
                fill: url(#SVGID_63_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10069 {
                fill: url(#SVGID_64_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10070 {
                fill: url(#SVGID_65_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10071 {
                fill: url(#SVGID_66_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10072 {
                fill: url(#SVGID_67_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10073 {
                fill: url(#SVGID_68_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10074 {
                fill: url(#SVGID_69_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10075 {
                fill: url(#SVGID_70_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10076 {
                fill: url(#SVGID_71_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10077 {
                fill: url(#SVGID_72_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10078 {
                fill: url(#SVGID_73_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10079 {
                fill: url(#SVGID_74_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10080 {
                fill: url(#SVGID_75_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10081 {
                fill: url(#SVGID_76_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10082 {
                fill: url(#SVGID_77_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10083 {
                fill: url(#SVGID_78_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10084 {
                fill: url(#SVGID_79_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10085 {
                fill: url(#SVGID_80_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10086 {
                fill: url(#SVGID_81_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10087 {
                fill: url(#SVGID_82_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10088 {
                fill: url(#SVGID_83_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10089 {
                fill: url(#SVGID_84_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10090 {
                fill: url(#SVGID_85_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10091 {
                fill: url(#SVGID_86_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10092 {
                fill: url(#SVGID_87_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10093 {
                fill: url(#SVGID_88_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10094 {
                fill: url(#SVGID_89_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10095 {
                fill: url(#SVGID_90_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10096 {
                fill: url(#SVGID_91_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10097 {
                fill: url(#SVGID_92_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10098 {
                fill: url(#SVGID_93_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain10099 {
                fill: url(#SVGID_94_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100100 {
                fill: url(#SVGID_95_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100101 {
                fill: url(#SVGID_96_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100102 {
                fill: url(#SVGID_97_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100103 {
                fill: url(#SVGID_98_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100104 {
                fill: url(#SVGID_99_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100105 {
                fill: url(#SVGID_100_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100106 {
                fill: url(#SVGID_101_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100107 {
                fill: url(#SVGID_102_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100108 {
                fill: url(#SVGID_103_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100109 {
                fill: url(#SVGID_104_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100110 {
                fill: url(#SVGID_105_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100111 {
                fill: url(#SVGID_106_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100112 {
                fill: url(#SVGID_107_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100113 {
                fill: url(#SVGID_108_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100114 {
                fill: url(#SVGID_109_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100115 {
                fill: url(#SVGID_110_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100116 {
                fill: url(#SVGID_111_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100117 {
                fill: url(#SVGID_112_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100118 {
                fill: url(#SVGID_113_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100119 {
                fill: url(#SVGID_114_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100120 {
                fill: url(#SVGID_115_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100121 {
                fill: url(#SVGID_116_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100122 {
                fill: url(#SVGID_117_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100123 {
                fill: url(#SVGID_118_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100124 {
                fill: url(#SVGID_119_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100125 {
                fill: url(#SVGID_120_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100126 {
                fill: url(#SVGID_121_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100127 {
                fill: url(#SVGID_122_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100128 {
                fill: url(#SVGID_123_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100129 {
                fill: url(#SVGID_124_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100130 {
                fill: url(#SVGID_125_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100131 {
                fill: url(#SVGID_126_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100132 {
                fill: url(#SVGID_127_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100133 {
                fill: url(#SVGID_128_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100134 {
                fill: url(#SVGID_129_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100135 {
                fill: url(#SVGID_130_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100136 {
                fill: url(#SVGID_131_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100137 {
                fill: url(#SVGID_132_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100138 {
                fill: url(#SVGID_133_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100139 {
                fill: url(#SVGID_134_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100140 {
                fill: url(#SVGID_135_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100141 {
                fill: url(#SVGID_136_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100142 {
                fill: url(#SVGID_137_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100143 {
                fill: url(#SVGID_138_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100144 {
                fill: url(#SVGID_139_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100145 {
                fill: url(#SVGID_140_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100146 {
                fill: url(#SVGID_141_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100147 {
                fill: url(#SVGID_142_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100148 {
                fill: url(#SVGID_143_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100149 {
                fill: url(#SVGID_144_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100150 {
                fill: url(#SVGID_145_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100151 {
                fill: url(#SVGID_146_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100152 {
                fill: url(#SVGID_147_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100153 {
                fill: url(#SVGID_148_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100154 {
                fill: url(#SVGID_149_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100155 {
                fill: url(#SVGID_150_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100156 {
                fill: url(#SVGID_151_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100157 {
                fill: url(#SVGID_152_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100158 {
                fill: url(#SVGID_153_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100159 {
                fill: url(#SVGID_154_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100160 {
                fill: url(#SVGID_155_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100161 {
                fill: url(#SVGID_156_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100162 {
                fill: url(#SVGID_157_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100163 {
                fill: url(#SVGID_158_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100164 {
                fill: url(#SVGID_159_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100165 {
                fill: url(#SVGID_160_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100166 {
                fill: url(#SVGID_161_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100167 {
                fill: url(#SVGID_162_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100168 {
                fill: url(#SVGID_163_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100169 {
                fill: url(#SVGID_164_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100170 {
                fill: url(#SVGID_165_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100171 {
                fill: url(#SVGID_166_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100172 {
                fill: url(#SVGID_167_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100173 {
                fill: url(#SVGID_168_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100174 {
                fill: url(#SVGID_169_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100175 {
                fill: url(#SVGID_170_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100176 {
                fill: url(#SVGID_171_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100177 {
                fill: url(#SVGID_172_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100178 {
                fill: url(#SVGID_173_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100179 {
                fill: url(#SVGID_174_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100180 {
                fill: url(#SVGID_175_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100181 {
                fill: url(#SVGID_176_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100182 {
                fill: url(#SVGID_177_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100183 {
                fill: url(#SVGID_178_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100184 {
                fill: url(#SVGID_179_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100185 {
                fill: url(#SVGID_180_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100186 {
                fill: url(#SVGID_181_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100187 {
                fill: url(#SVGID_182_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100188 {
                fill: url(#SVGID_183_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100189 {
                fill: url(#SVGID_184_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100190 {
                fill: url(#SVGID_185_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100191 {
                fill: url(#SVGID_186_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100192 {
                fill: url(#SVGID_187_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100193 {
                fill: url(#SVGID_188_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100194 {
                fill: url(#SVGID_189_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain100195 {
                fill: url(#SVGID_190_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }
        </style>
        <path
            d="M17,4.7c0-0.5-0.5-0.8-0.5-1c-3.2,0.5-4.2-0.9-8.1-0.4C3.3,4.1,0,6.1,0,6.1s5.7-2.4,9.5-2.3C13.7,3.8,14,5.2,17,4.7z"
        />
        <path
            d="M861.8,4.7c0-0.5,0.2-0.8,0.2-1c3.2,0.4,4.5-1,8.4-0.4c5,0.7,8.4,2.7,8.4,2.7s-5.7-2.4-9.5-2.3
        C865.1,3.8,864.8,5.2,861.8,4.7z"
        />
        <line class="stChain1000" x1="16.3" y1="4.3" x2="862.1" y2="4.3" />
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <g>
                <g>
                    <path
                        class="stChain10011"
                        d="M22.6,4.2c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.9-4.2-4.2S16,0,18.3,0C20.7,0,22.6,1.9,22.6,4.2z"
                    />
                </g>
            </g>
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M15.8,2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                    c-0.3-0.4-1.1-0.3-1.6-0.2C16.8,0.9,16.1,1.4,15.8,2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M22.6,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C24.5,8.4,22.6,6.5,22.6,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M24.4,2.1c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3C26.6,2,28,1.5,27.6,1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C25.4,1,24.7,1.5,24.4,2.1z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M31.1,4.2C31.1,1.9,33,0,35.4,0c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C33,8.4,31.1,6.5,31.1,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M33,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C34,1.2,33.4,1.6,33,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M39.7,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C41.5,8.4,39.7,6.5,39.7,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M41.4,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C42.4,1.2,41.8,1.6,41.4,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M48.2,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C50.1,8.4,48.2,6.5,48.2,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M49.9,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C50.9,1.2,50.2,1.6,49.9,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <g>
                <path
                    class="stChain10023"
                    d="M65.2,4.2c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.9-4.2-4.2S58.6,0,60.9,0C63.3,0,65.2,1.9,65.2,4.2z"
                />
            </g>
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M58.4,2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3C60.7,1.9,62,1.4,61.7,1
                c-0.3-0.4-1.1-0.3-1.6-0.2C59.4,0.9,58.7,1.4,58.4,2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M65.2,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C67.1,8.4,65.2,6.5,65.2,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M67,2.1c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C68,1,67.3,1.5,67,2.1z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M73.7,4.2C73.7,1.9,75.6,0,78,0c2.3,0,4.2,1.9,4.2,4.2S80.3,8.4,78,8.4C75.6,8.4,73.7,6.5,73.7,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M75.6,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C76.6,1.2,76,1.6,75.6,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M82.3,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C84.2,8.4,82.3,6.5,82.3,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M84,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                C87,0.8,86.2,0.9,85.8,1C85,1.2,84.4,1.6,84,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M90.8,4.2C90.8,1.9,92.7,0,95,0c2.3,0,4.2,1.9,4.2,4.2S97.3,8.4,95,8.4C92.7,8.4,90.8,6.5,90.8,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M92.5,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C93.5,1.2,92.8,1.6,92.5,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <g>
                <g>
                    <path
                        class="stChain10011"
                        d="M107.7,4.2c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2C105.8,0,107.7,1.9,107.7,4.2z"
                    />
                </g>
            </g>
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M100.9,2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C101.9,0.9,101.2,1.4,100.9,2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M107.7,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C109.6,8.4,107.7,6.5,107.7,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M109.5,2.1c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C110.5,1,109.8,1.5,109.5,2.1z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M116.2,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C118.1,8.4,116.2,6.5,116.2,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M118.1,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C119.1,1.2,118.4,1.6,118.1,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M124.7,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C126.6,8.4,124.7,6.5,124.7,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M126.5,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C127.5,1.2,126.9,1.6,126.5,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M133.3,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C135.1,8.4,133.3,6.5,133.3,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M135,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C136,1.2,135.3,1.6,135,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <g>
                <path
                    class="stChain10023"
                    d="M150.3,4.2c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.9-4.2-4.2S143.7,0,146,0C148.4,0,150.3,1.9,150.3,4.2z"
                />
            </g>
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M143.5,2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C144.5,0.9,143.8,1.4,143.5,2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M150.3,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C152.2,8.4,150.3,6.5,150.3,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M152.1,2.1c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C153.1,1,152.4,1.5,152.1,2.1z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M158.8,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C160.7,8.4,158.8,6.5,158.8,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M160.7,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C161.7,1.2,161,1.6,160.7,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M167.4,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C169.2,8.4,167.4,6.5,167.4,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M169.1,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C170.1,1.2,169.5,1.6,169.1,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M175.9,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C177.8,8.4,175.9,6.5,175.9,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M177.6,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C178.6,1.2,177.9,1.6,177.6,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <g>
                <g>
                    <path
                        class="stChain10011"
                        d="M192.7,4.2c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2C190.8,0,192.7,1.9,192.7,4.2z"
                    />
                </g>
            </g>
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M185.9,2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C186.9,0.9,186.3,1.4,185.9,2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M192.8,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C194.7,8.4,192.8,6.5,192.8,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M194.5,2.1c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C195.5,1,194.8,1.5,194.5,2.1z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M201.3,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C203.2,8.4,201.3,6.5,201.3,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M203.1,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C204.1,1.2,203.5,1.6,203.1,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M209.8,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C211.7,8.4,209.8,6.5,209.8,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M211.6,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C212.6,1.2,211.9,1.6,211.6,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M218.3,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C220.2,8.4,218.3,6.5,218.3,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M220,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C221,1.2,220.3,1.6,220,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <g>
                <path
                    class="stChain10023"
                    d="M235.3,4.2c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2C233.4,0,235.3,1.9,235.3,4.2z"
                />
            </g>
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M228.5,2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C229.5,0.9,228.9,1.4,228.5,2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M235.4,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C237.3,8.4,235.4,6.5,235.4,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M237.1,2.1c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C238.1,1,237.4,1.5,237.1,2.1z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M243.9,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C245.8,8.4,243.9,6.5,243.9,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M245.7,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C246.7,1.2,246.1,1.6,245.7,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M252.4,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C254.3,8.4,252.4,6.5,252.4,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M254.2,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C255.2,1.2,254.5,1.6,254.2,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M260.9,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C262.8,8.4,260.9,6.5,260.9,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M262.6,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C263.6,1.2,262.9,1.6,262.6,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <g>
                <g>
                    <path
                        class="stChain10011"
                        d="M277.8,4.2c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2C275.9,0,277.8,1.9,277.8,4.2z"
                    />
                </g>
            </g>
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M271,2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C272,0.9,271.4,1.4,271,2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M277.9,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C279.7,8.4,277.9,6.5,277.9,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M279.6,2.1c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C280.6,1,279.9,1.5,279.6,2.1z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M286.4,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C288.3,8.4,286.4,6.5,286.4,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M288.2,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C289.2,1.2,288.6,1.6,288.2,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M294.9,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C296.8,8.4,294.9,6.5,294.9,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M296.7,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C297.7,1.2,297,1.6,296.7,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M303.4,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C305.3,8.4,303.4,6.5,303.4,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M305.1,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C306.1,1.2,305.4,1.6,305.1,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <g>
                <path
                    class="stChain10023"
                    d="M320.4,4.2c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2C318.5,0,320.4,1.9,320.4,4.2z"
                />
            </g>
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M313.6,2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C314.6,0.9,314,1.4,313.6,2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M320.5,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C322.3,8.4,320.5,6.5,320.5,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M322.2,2.1c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C323.2,1,322.5,1.5,322.2,2.1z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M329,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C330.9,8.4,329,6.5,329,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M330.8,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C331.8,1.2,331.2,1.6,330.8,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M337.5,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C339.4,8.4,337.5,6.5,337.5,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M339.3,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C340.3,1.2,339.6,1.6,339.3,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M346,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C347.9,8.4,346,6.5,346,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M347.7,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C348.7,1.2,348,1.6,347.7,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <g>
                <g>
                    <path
                        class="stChain10011"
                        d="M362.7,4.2c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2C360.8,0,362.7,1.9,362.7,4.2z"
                    />
                </g>
            </g>
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M355.9,2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C356.9,0.9,356.2,1.4,355.9,2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M362.7,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C364.6,8.4,362.7,6.5,362.7,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M364.5,2.1c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C365.5,1,364.8,1.5,364.5,2.1z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M371.3,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C373.1,8.4,371.3,6.5,371.3,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M373.1,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C374.1,1.2,373.5,1.6,373.1,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M379.8,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C381.7,8.4,379.8,6.5,379.8,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M381.6,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C382.6,1.2,381.9,1.6,381.6,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M388.3,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C390.2,8.4,388.3,6.5,388.3,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M390,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C391,1.2,390.3,1.6,390,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <g>
                <path
                    class="stChain10023"
                    d="M405.3,4.2c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2C403.4,0,405.3,1.9,405.3,4.2z"
                />
            </g>
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M398.5,2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C399.5,0.9,398.8,1.4,398.5,2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M405.3,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C407.2,8.4,405.3,6.5,405.3,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M407.1,2.1c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C408.1,1,407.4,1.5,407.1,2.1z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M413.9,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C415.7,8.4,413.9,6.5,413.9,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M415.7,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C416.7,1.2,416.1,1.6,415.7,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M422.4,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C424.3,8.4,422.4,6.5,422.4,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M424.2,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C425.2,1.2,424.5,1.6,424.2,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M430.9,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C432.8,8.4,430.9,6.5,430.9,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M432.6,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C433.6,1.2,432.9,1.6,432.6,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <g>
                <g>
                    <path
                        class="stChain10011"
                        d="M447.8,4.2c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2C445.9,0,447.8,1.9,447.8,4.2z"
                    />
                </g>
            </g>
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M441,2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C442,0.9,441.3,1.4,441,2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M447.8,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C449.7,8.4,447.8,6.5,447.8,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M449.6,2.1c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C450.6,1,449.9,1.5,449.6,2.1z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M456.3,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C458.2,8.4,456.3,6.5,456.3,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M458.2,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C459.2,1.2,458.6,1.6,458.2,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M464.9,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C466.7,8.4,464.9,6.5,464.9,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M466.6,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C467.6,1.2,467,1.6,466.6,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M473.4,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C475.3,8.4,473.4,6.5,473.4,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M475.1,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C476.1,1.2,475.4,1.6,475.1,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <g>
                <path
                    class="stChain10023"
                    d="M490.4,4.2c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2C488.5,0,490.4,1.9,490.4,4.2z"
                />
            </g>
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M483.6,2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C484.6,0.9,483.9,1.4,483.6,2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M490.4,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C492.3,8.4,490.4,6.5,490.4,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M492.2,2.1c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C493.2,1,492.5,1.5,492.2,2.1z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M498.9,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C500.8,8.4,498.9,6.5,498.9,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M500.8,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C501.8,1.2,501.2,1.6,500.8,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M507.5,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C509.3,8.4,507.5,6.5,507.5,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M509.2,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C510.2,1.2,509.6,1.6,509.2,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M516,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C517.9,8.4,516,6.5,516,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M517.7,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C518.7,1.2,518,1.6,517.7,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <g>
                <g>
                    <path
                        class="stChain10011"
                        d="M532.9,4.2c0,2.3-1.9,4.2-4.2,4.2s-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2S532.9,1.9,532.9,4.2z"
                    />
                </g>
            </g>
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M526.1,2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C527.1,0.9,526.4,1.4,526.1,2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M532.9,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C534.8,8.4,532.9,6.5,532.9,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M534.7,2.1c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C535.7,1,535,1.5,534.7,2.1z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M541.4,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C543.3,8.4,541.4,6.5,541.4,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M543.3,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C544.3,1.2,543.6,1.6,543.3,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M549.9,4.2c0-2.3,1.9-4.2,4.2-4.2s4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2S549.9,6.5,549.9,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M551.7,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C552.7,1.2,552.1,1.6,551.7,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M558.5,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C560.3,8.4,558.5,6.5,558.5,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M560.2,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C561.2,1.2,560.5,1.6,560.2,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <g>
                <path
                    class="stChain10023"
                    d="M575.5,4.2c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2C573.6,0,575.5,1.9,575.5,4.2z"
                />
            </g>
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M568.7,2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C569.7,0.9,569,1.4,568.7,2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M575.5,4.2c0-2.3,1.9-4.2,4.2-4.2s4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2S575.5,6.5,575.5,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M577.3,2.1c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C578.3,1,577.6,1.5,577.3,2.1z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M584,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C585.9,8.4,584,6.5,584,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M585.9,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C586.9,1.2,586.2,1.6,585.9,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M592.5,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C594.4,8.4,592.5,6.5,592.5,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M594.3,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C595.3,1.2,594.7,1.6,594.3,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M601.1,4.2c0-2.3,1.9-4.2,4.2-4.2s4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2S601.1,6.5,601.1,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M602.8,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C603.8,1.2,603.1,1.6,602.8,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <g>
                <g>
                    <path
                        class="stChain10011"
                        d="M617.9,4.2c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2C616.1,0,617.9,1.9,617.9,4.2z"
                    />
                </g>
            </g>
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M611.2,2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C612.2,0.9,611.5,1.4,611.2,2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M618,4.2c0-2.3,1.9-4.2,4.2-4.2s4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2S618,6.5,618,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M619.7,2.1c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C620.7,1,620.1,1.5,619.7,2.1z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M626.5,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C628.4,8.4,626.5,6.5,626.5,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M628.4,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C629.4,1.2,628.7,1.6,628.4,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M635,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C636.9,8.4,635,6.5,635,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M636.8,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C637.8,1.2,637.2,1.6,636.8,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M643.5,4.2c0-2.3,1.9-4.2,4.2-4.2s4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2S643.5,6.5,643.5,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M645.3,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C646.3,1.2,645.6,1.6,645.3,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <g>
                <path
                    class="stChain10023"
                    d="M660.5,4.2c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.9-4.2-4.2S654,0,656.3,0C658.7,0,660.5,1.9,660.5,4.2z"
                />
            </g>
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M653.8,2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C654.8,0.9,654.1,1.4,653.8,2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M660.6,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C662.5,8.4,660.6,6.5,660.6,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M662.3,2.1c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C663.3,1,662.7,1.5,662.3,2.1z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M669.1,4.2c0-2.3,1.9-4.2,4.2-4.2s4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2S669.1,6.5,669.1,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M671,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C672,1.2,671.3,1.6,671,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M677.6,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C679.5,8.4,677.6,6.5,677.6,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M679.4,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C680.4,1.2,679.8,1.6,679.4,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M686.1,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C688,8.4,686.1,6.5,686.1,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M687.9,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C688.9,1.2,688.2,1.6,687.9,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <g>
                <g>
                    <path
                        class="stChain10011"
                        d="M702.9,4.2c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2C701,0,702.9,1.9,702.9,4.2z"
                    />
                </g>
            </g>
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M696.2,2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C697.2,0.9,696.5,1.4,696.2,2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M703,4.2c0-2.3,1.9-4.2,4.2-4.2s4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2S703,6.5,703,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M704.7,2.1c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C705.7,1,705.1,1.5,704.7,2.1z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M711.5,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C713.4,8.4,711.5,6.5,711.5,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M713.4,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C714.4,1.2,713.7,1.6,713.4,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M720,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C721.9,8.4,720,6.5,720,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M721.8,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C722.8,1.2,722.2,1.6,721.8,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M728.5,4.2c0-2.3,1.9-4.2,4.2-4.2s4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2S728.5,6.5,728.5,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M730.2,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C731.2,1.2,730.6,1.6,730.2,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <g>
                <path
                    class="stChain10023"
                    d="M745.5,4.2c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.9-4.2-4.2S739,0,741.3,0C743.6,0,745.5,1.9,745.5,4.2z"
                />
            </g>
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M738.8,2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C739.8,0.9,739.1,1.4,738.8,2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M745.6,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C747.5,8.4,745.6,6.5,745.6,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M747.3,2.1c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C748.3,1,747.7,1.5,747.3,2.1z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M754.1,4.2c0-2.3,1.9-4.2,4.2-4.2s4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2S754.1,6.5,754.1,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M756,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C757,1.2,756.3,1.6,756,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M762.6,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C764.5,8.4,762.6,6.5,762.6,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M764.4,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C765.4,1.2,764.8,1.6,764.4,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M771.1,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C773,8.4,771.1,6.5,771.1,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M772.8,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C773.8,1.2,773.2,1.6,772.8,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <g>
                <g>
                    <path
                        class="stChain10011"
                        d="M788,4.2c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2C786.1,0,788,1.9,788,4.2z"
                    />
                </g>
            </g>
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M781.2,2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C782.3,0.9,781.6,1.4,781.2,2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M788.1,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C790,8.4,788.1,6.5,788.1,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M789.8,2.1c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C790.8,1,790.2,1.5,789.8,2.1z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M796.6,4.2c0-2.3,1.9-4.2,4.2-4.2s4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2S796.6,6.5,796.6,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M798.5,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C799.5,1.2,798.8,1.6,798.5,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M805.1,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C807,8.4,805.1,6.5,805.1,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M806.9,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C807.9,1.2,807.2,1.6,806.9,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10011"
                d="M813.6,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C815.5,8.4,813.6,6.5,813.6,4.2"
            />
            <g class="stChain10012">
                <g>
                    <path
                        class="stChain10013"
                        d="M815.3,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C816.3,1.2,815.7,1.6,815.3,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <g>
                <path
                    class="stChain10023"
                    d="M830.6,4.2c0,2.3-1.9,4.2-4.2,4.2s-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2S830.6,1.9,830.6,4.2z"
                />
            </g>
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M823.9,2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C824.9,0.9,824.2,1.4,823.9,2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M830.7,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C832.6,8.4,830.7,6.5,830.7,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M832.4,2.1c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C833.4,1,832.8,1.5,832.4,2.1z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M839.2,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C841.1,8.4,839.2,6.5,839.2,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M841.1,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C842.1,1.2,841.4,1.6,841.1,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M847.7,4.2c0-2.3,1.9-4.2,4.2-4.2s4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2S847.7,6.5,847.7,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M849.5,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C850.5,1.2,849.8,1.6,849.5,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain10023"
                d="M856.2,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C858.1,8.4,856.2,6.5,856.2,4.2"
            />
            <g class="stChain10024">
                <g>
                    <path
                        class="stChain10013"
                        d="M857.9,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C858.9,1.2,858.3,1.6,857.9,2.2z"
                    />
                </g>
            </g>
        </g>
    </svg>
    @if (showNumberLine) {
    <svg
        version="1.1"
        class="number-line"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 461.497 24.201"
        style="enable-background: new 0 0 461.497 24.201"
        xml:space="preserve"
    >
        <path
            style="fill: none; stroke: #000000; stroke-width: 0.5"
            d="M0,7.087h461.497"
        />
        @if (showNumbers) {
        <g class="chain100-numbers">
            <g style="enable-background: new">
                <path
                    d="M5.693,21.053c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                C6.194,24.146,5.693,22.786,5.693,21.053z M9.203,21.053c0-1.419-0.323-2.533-1.454-2.533s-1.453,1.113-1.453,2.533
                c0,1.428,0.323,2.541,1.453,2.541S9.203,22.48,9.203,21.053z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M48.386,23.517h1.334v-4.386c0-0.17,0.008-0.332,0.008-0.332h-0.017c0,0-0.059,0.127-0.297,0.357l-0.637,0.638
                l-0.374-0.382l1.351-1.343h0.561v5.448h1.309v0.527h-3.238V23.517z"
                />
                <path
                    d="M52.262,21.053c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                C52.764,24.146,52.262,22.786,52.262,21.053z M55.772,21.053c0-1.419-0.323-2.533-1.454-2.533s-1.453,1.113-1.453,2.533
                c0,1.428,0.323,2.541,1.453,2.541S55.772,22.48,55.772,21.053z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M95.555,19.65c0-0.638-0.467-1.122-1.224-1.122c-0.595,0-1.062,0.306-1.062,0.646v0.281h-0.561v-0.442
                c0-0.756,1.028-1.045,1.641-1.045c1.139,0,1.818,0.748,1.818,1.674c0,2.099-3.162,2.048-3.162,3.706c0,0.119,0.068,0.17,0.196,0.17
                h2.499c0.119,0,0.187-0.06,0.187-0.187v-0.399h0.552v0.595c0,0.366-0.153,0.519-0.518,0.519h-2.992
                c-0.408,0-0.536-0.17-0.536-0.586C92.393,21.24,95.555,21.418,95.555,19.65z"
                />
                <path
                    d="M97.289,21.053c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                C97.79,24.146,97.289,22.786,97.289,21.053z M100.799,21.053c0-1.419-0.323-2.533-1.454-2.533s-1.453,1.113-1.453,2.533
                c0,1.428,0.323,2.541,1.453,2.541S100.799,22.48,100.799,21.053z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M137.356,22.871c0,0,0.612,0.714,1.563,0.714c0.706,0,1.352-0.527,1.352-1.292c0-0.807-0.697-1.258-1.453-1.258h-0.417
                l-0.136-0.348l1.47-1.768c0.145-0.195,0.306-0.332,0.306-0.332v-0.017c0,0-0.17,0.026-0.484,0.026h-1.556
                c-0.119,0-0.187,0.059-0.187,0.187v0.399h-0.553v-0.595c0-0.365,0.136-0.519,0.501-0.519h3.034v0.391l-1.759,2.065
                c0.748,0.042,1.844,0.476,1.844,1.759c0,1.011-0.841,1.861-1.972,1.861c-1.181,0-1.912-0.833-1.912-0.833L137.356,22.871z"
                />
                <path
                    d="M141.767,21.053c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                C142.268,24.146,141.767,22.786,141.767,21.053z M145.277,21.053c0-1.419-0.323-2.533-1.454-2.533s-1.453,1.113-1.453,2.533
                c0,1.428,0.323,2.541,1.453,2.541S145.277,22.48,145.277,21.053z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M181.371,22.005l2.907-3.936h0.637v3.799h0.952v0.527h-0.952v1.649h-0.595v-1.649h-2.949V22.005z M184.328,19.429
                c0-0.255,0.026-0.578,0.026-0.578h-0.017c0,0-0.145,0.247-0.306,0.459l-1.657,2.193c-0.162,0.212-0.314,0.374-0.314,0.374v0.017
                c0,0,0.238-0.025,0.493-0.025h1.776V19.429z"
                />
                <path
                    d="M186.521,21.053c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                C187.023,24.146,186.521,22.786,186.521,21.053z M190.032,21.053c0-1.419-0.323-2.533-1.454-2.533s-1.453,1.113-1.453,2.533
                c0,1.428,0.323,2.541,1.453,2.541S190.032,22.48,190.032,21.053z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M226.686,22.88c0,0,0.45,0.706,1.385,0.706c0.85,0,1.487-0.604,1.487-1.394c0-0.824-0.688-1.402-1.547-1.402
            c-0.671,0-1.147,0.332-1.147,0.332l-0.306-0.127l0.255-2.405c0.034-0.365,0.153-0.519,0.519-0.519h1.963
            c0.357,0,0.51,0.153,0.51,0.519v0.595h-0.552v-0.399c0-0.128-0.068-0.187-0.187-0.187h-1.513c-0.119,0-0.17,0.059-0.187,0.187
            l-0.153,1.351c-0.025,0.212-0.051,0.34-0.051,0.34h0.017c0,0,0.374-0.221,0.901-0.221c1.216,0,2.091,0.867,2.091,1.946
            c0,1.062-0.884,1.946-2.099,1.946c-1.19,0-1.759-0.85-1.759-0.85L226.686,22.88z"
                />
                <path
                    d="M231.132,21.053c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
            C231.633,24.146,231.132,22.786,231.132,21.053z M234.642,21.053c0-1.419-0.323-2.533-1.454-2.533s-1.453,1.113-1.453,2.533
            c0,1.428,0.323,2.541,1.453,2.541S234.642,22.48,234.642,21.053z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M270.871,21.418c0-1.521,0.782-3.45,2.626-3.45c0.654,0,1.097,0.246,1.097,0.246l-0.221,0.519
                    c0,0-0.374-0.212-0.867-0.212c-1.249,0-1.887,1.25-1.997,2.456h0.017c0.28-0.467,0.901-0.722,1.521-0.722
                    c1.088,0,1.861,0.782,1.861,1.895c0,1.241-0.833,1.998-1.878,1.998C271.729,24.146,270.871,22.982,270.871,21.418z
                    M273.021,23.594c0.808,0,1.283-0.612,1.283-1.436c0-0.833-0.535-1.377-1.352-1.377c-0.799,0-1.444,0.536-1.444,1.02
                    C271.508,22.591,272.128,23.594,273.021,23.594z"
                />
                <path
                    d="M275.699,21.053c0-1.717,0.501-3.085,2.057-3.085s2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                    S275.699,22.786,275.699,21.053z M279.208,21.053c0-1.419-0.323-2.533-1.453-2.533c-1.131,0-1.453,1.113-1.453,2.533
                    c0,1.428,0.322,2.541,1.453,2.541C278.885,23.594,279.208,22.48,279.208,21.053z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M318.642,19.149c0.171-0.323,0.332-0.552,0.332-0.552v-0.017c0,0-0.153,0.017-0.45,0.017h-2.15
                c-0.119,0-0.188,0.059-0.188,0.187v0.399h-0.561v-0.595c0-0.365,0.145-0.519,0.51-0.519h3.527v0.408l-2.958,5.567h-0.663
                L318.642,19.149z"
                />
                <path
                    d="M320.054,21.053c0-1.717,0.501-3.085,2.057-3.085s2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                S320.054,22.786,320.054,21.053z M323.564,21.053c0-1.419-0.323-2.533-1.453-2.533c-1.131,0-1.453,1.113-1.453,2.533
                c0,1.428,0.322,2.541,1.453,2.541C323.241,23.594,323.564,22.48,323.564,21.053z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M361.158,20.781v-0.017c0,0-0.816-0.382-0.816-1.232c0-0.824,0.646-1.563,1.802-1.563c1.131,0,1.827,0.663,1.827,1.589
                c0,0.91-0.799,1.479-0.799,1.479v0.017c0.562,0.289,0.961,0.671,0.961,1.368c0,0.935-0.867,1.726-2.006,1.726
                c-1.054,0-2.031-0.654-2.031-1.785C360.095,21.316,361.158,20.781,361.158,20.781z M362.126,23.594
                c0.705,0,1.394-0.484,1.394-1.181c0-0.621-0.51-0.867-1.139-1.122c-0.221-0.093-0.629-0.238-0.697-0.238
                c-0.229,0-0.978,0.544-0.978,1.283C360.706,23.118,361.395,23.594,362.126,23.594z M362.62,20.781
                c0.212,0,0.756-0.586,0.756-1.207c0-0.646-0.51-1.054-1.232-1.054c-0.756,0-1.207,0.45-1.207,1.011
                c0,0.629,0.527,0.858,1.147,1.088C362.22,20.67,362.508,20.781,362.62,20.781z"
                />
                <path
                    d="M364.949,21.053c0-1.717,0.501-3.085,2.057-3.085s2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                S364.949,22.786,364.949,21.053z M368.458,21.053c0-1.419-0.323-2.533-1.453-2.533c-1.131,0-1.453,1.113-1.453,2.533
                c0,1.428,0.322,2.541,1.453,2.541C368.135,23.594,368.458,22.48,368.458,21.053z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M405.214,23.381c0,0,0.374,0.212,0.867,0.212c1.249,0,1.896-1.258,1.997-2.464h-0.017
                c-0.281,0.467-0.901,0.731-1.521,0.731c-1.088,0-1.854-0.782-1.854-1.896c0-1.241,0.825-1.997,1.87-1.997
                c1.301,0,2.159,1.164,2.159,2.728c0,1.521-0.773,3.451-2.626,3.451c-0.655,0-1.097-0.247-1.097-0.247L405.214,23.381z
                M408.079,20.313c0-0.791-0.62-1.793-1.513-1.793c-0.808,0-1.283,0.612-1.283,1.437c0,0.833,0.535,1.376,1.352,1.376
                C407.433,21.333,408.079,20.798,408.079,20.313z"
                />
                <path
                    d="M409.54,21.053c0-1.717,0.502-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                C410.042,24.146,409.54,22.786,409.54,21.053z M413.051,21.053c0-1.419-0.323-2.533-1.454-2.533c-1.13,0-1.453,1.113-1.453,2.533
                c0,1.428,0.323,2.541,1.453,2.541C412.728,23.594,413.051,22.48,413.051,21.053z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M447.318,23.517h1.334v-4.386c0-0.17,0.009-0.332,0.009-0.332h-0.018c0,0-0.059,0.127-0.297,0.357l-0.638,0.638
                l-0.374-0.382l1.352-1.343h0.561v5.448h1.31v0.527h-3.238V23.517z"
                />
                <path
                    d="M451.194,21.053c0-1.717,0.501-3.085,2.057-3.085s2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                S451.194,22.786,451.194,21.053z M454.704,21.053c0-1.419-0.323-2.533-1.453-2.533c-1.131,0-1.453,1.113-1.453,2.533
                c0,1.428,0.322,2.541,1.453,2.541C454.38,23.594,454.704,22.48,454.704,21.053z"
                />
                <path
                    d="M456.31,21.053c0-1.717,0.502-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                C456.812,24.146,456.31,22.786,456.31,21.053z M459.821,21.053c0-1.419-0.323-2.533-1.454-2.533c-1.13,0-1.453,1.113-1.453,2.533
                c0,1.428,0.323,2.541,1.453,2.541C459.497,23.594,459.821,22.48,459.821,21.053z"
                />
            </g>
        </g>
        }
        <g class="chain100-big-ticks">
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M7.75,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M52.36,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M96.969,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M141.579,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M186.189,1.417v11.339"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M230.799,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M275.409,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M320.019,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M364.629,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M409.239,1.417v11.339"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M453.849,0v14.173"
            />
        </g>
        @if (showUnits) {
        <g class="chain100-small-ticks">
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M12.211,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M16.672,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M21.133,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M25.594,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M34.516,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M38.977,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M30.055,2.835v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M43.438,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M47.899,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M56.821,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M61.282,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M65.743,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M70.204,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M79.126,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M83.587,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M74.665,2.835v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M88.048,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M92.508,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M101.43,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M105.892,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M110.353,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M114.813,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M123.735,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M128.197,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M119.274,2.835v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M132.658,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M137.118,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M146.04,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M150.501,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M154.962,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M159.423,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M168.346,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M172.807,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M163.885,2.835v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M177.268,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M181.729,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M190.65,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M195.111,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M199.572,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M204.033,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M212.956,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M217.417,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M208.495,3.189v7.795"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M221.878,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M226.339,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M235.26,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M239.721,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M244.182,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M248.643,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M257.565,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M262.026,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M253.104,2.835v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M266.487,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M270.948,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M279.87,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M284.332,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M288.793,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M293.254,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M302.176,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M306.636,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M297.715,2.835v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M311.097,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M315.558,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M324.48,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M328.941,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M333.402,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M337.863,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M346.785,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M351.246,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M342.324,2.835v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M355.707,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M360.168,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M369.09,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M373.551,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M378.012,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M382.473,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M391.395,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M395.856,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M386.934,2.835v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M400.317,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M404.778,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M413.7,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M418.161,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M422.622,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M427.083,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M436.005,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M440.466,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M431.544,3.189v7.795"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M444.927,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M449.388,4.252v5.669"
            />
        </g>
        }
    </svg>
    }
</ng-template>
